export function setSessionStorage<_, K>(key: string, payload: K): void {
	return sessionStorage.setItem(key, JSON.stringify(payload));
}

export function getSessionStorage(key: string): void {
	const payload = sessionStorage.getItem(key);

	return payload ? JSON.parse(payload) : null;
}

export function clearSessionStorage(key?: string): void {
	return (key ? sessionStorage.removeItem(key) : sessionStorage.clear());
}

export function setLocalStorage<_, K>(key: string, payload: K): void {
	return localStorage.setItem(key, JSON.stringify(payload));
}

export function getLocalStorage(key: string): number {
	const payload = localStorage.getItem(key);

	return payload ? JSON.parse(payload) : null;
}

export function clearLocalStorage(key?: string): void {
	return (key ? localStorage.removeItem(key) : localStorage.clear());
}
